/* eslint-disable max-len */
const ArrowRightDownSolidIcon = ({ className = '' }) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <ellipse cx="15.7869" cy="16" rx="16" ry="15.7862" transform="rotate(90 15.7869 16)" fill="currentColor" />
    <path d="M22.6934 10.3064L21.4668 10.3064L21.4668 20.6326L9.73808 9L8.88045 9.88892L20.5764 21.4884L10.1878 21.4884L10.1878 22.7317L22.6934 22.7317L22.6934 10.3064Z" fill="#F7F7FA" />
  </svg>
);

export default ArrowRightDownSolidIcon;
